import { render } from "./PropertyBehavior.vue?vue&type=template&id=2d1fb897&scoped=true&ts=true"
import script from "./PropertyBehavior.vue?vue&type=script&lang=ts"
export * from "./PropertyBehavior.vue?vue&type=script&lang=ts"

import "./PropertyBehavior.vue?vue&type=style&index=0&id=2d1fb897&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1fb897"]])

export default __exports__